module.exports = __webpack_public_path__ + "689ab0d98071e0c0e176715771f2e3b8.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/LK.svg
// module id = bzfS
// module chunks = 0